module.exports = __webpack_public_path__ + "static/assets/1e4fc169fa222ff92a543c090adab467.png";